module.exports = __webpack_public_path__ + "static/media/humza icons-01.b9eee795.svg";